import type {
  ListMbcAdminChecksResponse,
  MbcAdminCheck,
  MbcAdminCheckResponse,
  MbcAdminCreateCheckBody,
  MbcAdminUpdateCheckBody,
} from "@nlc/shared-types";

import { adminRequest } from "../adminRequest";

export async function listChecks(): Promise<MbcAdminCheck[]> {
  const { checks } = await adminRequest<ListMbcAdminChecksResponse>("/checks");

  return checks;
}

export async function createCheck(
  body: MbcAdminCreateCheckBody,
): Promise<MbcAdminCheck> {
  const { check } = await adminRequest<MbcAdminCheckResponse>(
    "/checks",
    "POST",
    body,
  );

  return check;
}

export async function updateCheck({
  checkId,
  ...body
}: {
  checkId: string;
} & MbcAdminUpdateCheckBody): Promise<MbcAdminCheck> {
  const { check } = await adminRequest<MbcAdminCheckResponse>(
    `/checks/${encodeURIComponent(checkId)}`,
    "PUT",
    body,
  );

  return check;
}

export async function deleteCheck(checkId: string): Promise<void> {
  await adminRequest(`/checks/${encodeURIComponent(checkId)}`, "DELETE");
}
